import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchData(ctx,queryParams){
            var data = JSON.stringify(queryParams);
              
            return new Promise((resolve, reject) => {
              axios
                .post('/pages/v1/getall',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
          },
          addData(ctx,queryParams){
              //var data = JSON.stringify(queryParams);
              
              return new Promise((resolve, reject) => {
                axios
                  .post('/pages/v1/add',queryParams.formData)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
  
          },
          updateData(ctx,queryParams){
           
             // var data = JSON.stringify(queryParams.formData);
              
              return new Promise((resolve, reject) => {
                axios
                  .put('/pages/v1/update/'+queryParams.data.id,queryParams.formData,{
                    headers:{
                      'Content-Type': 'multipart/form-data',
                      'dataType':'json'
                    }
                  })
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
  
          },
          deleteData(ctx,id){
            
              
            return new Promise((resolve, reject) => {
              axios
                .delete('/pages/v1/delete/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
  
          },updatePageOrdering(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .put('/pages/v1/pages/updateOrdering',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
          },updateComponentsGroupsOrdering(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .put('/pages/v1/contents/updateOrdering',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        uploadImage(ctx, queryParams){
          return new Promise((resolve, reject) => {
            axios
              .post('/pages/v1/uploadImage', queryParams.formData)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })
        },
    }
}